@if (!hasPriseDeRdvService) {
<div class="grow flex items-center justify-center min-h-48">
  <div class="bg-primary text-white rounded-lg text-[12px] flex items-center gap-x-2 font-medium p-1">
    <lucide-icon [img]="AlertCircleIcon" [size]="16"></lucide-icon>
    Ce professionnel ne prend pas de rendez-vous en ligne.
  </div>
</div>
} @else if (shouldShowSlots && structureForSlots) {
@if (isMultiStructure) {
<div class="space-y-3 mb-4">
  <div class="inline-flex items-center gap-x-2 text-[13px] font-medium text-gray-700">
    <div class="p-1 flex items-center justify-center bg-primary/20 rounded-md">
      <lucide-icon [img]="BuildingIcon" [size]="16" class="text-primary"></lucide-icon>
    </div>
    Ce médecin exerce dans plusieurs structures. Cliquez sur une structure pour afficher les créneaux correspondants.
  </div>
  <div class="flex flex-wrap gap-2">
    @for (structure of structuresWithSlots; track structure.id) {
    <button type="button" class="px-4 py-2 rounded-lg text-[13px] font-medium transition-colors " [ngClass]="isStructureActive(structure)
              ? 'bg-primary text-white border-primary'
              : 'bg-gray-100 text-gray-600 '" (click)="selectStructure(structure)">
      {{ structure.name }}
    </button>
    }
  </div>
</div>
}
<app-doctor-slots [doctorId]="doctor.eyoneExternalId ?? doctor.eyone_external_id"
  [structureId]="getStructureEyoneId(structureForSlots)"
  [doctorName]="(doctor.title?.name ?? '') + ' ' + (doctor.firstname ?? '') + ' ' + (doctor.lastname ?? '')"
  [structureName]="structureForSlots.name" [specialisations]="doctor.specialisations ?? []"
  [reasons]="doctor.doctorAppointmentReasons ?? []">
</app-doctor-slots>
} @else {
<div class="grow flex items-center justify-center min-h-48">
  <div class="rounded-lg text-[13px] text-gray-600 bg-gray-100 px-4 py-3">
    <lucide-icon [img]="AlertCircleIcon" [size]="16" class="inline-block align-middle mr-2"></lucide-icon>
    Aucun créneau disponible pour le moment pour ce professionnel.
  </div>
</div>
}